import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=2cb81b92&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=2cb81b92&lang=scss&scoped=true&"
import style1 from "./menu.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./menu.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb81b92",
  null
  
)

export default component.exports
import {QScrollArea,QList,QExpansionItem,QItemSection,QBadge,QItem,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QScrollArea,QList,QExpansionItem,QItemSection,QBadge,QItem,QIcon})
